/**
 * Loads linked products based on SKU when on a product page.
 */ 

const loadLinkedProducts = (currentSku, linkedProductContainer) => {
  if (location.pathname.includes('/products/') || location.pathname.includes('/collections/')) {
    const isProductCard = linkedProductContainer.closest('product-card');
    
    let linkedProducts = [];
    linkedProducts = window.products.filter(product => product.sku?.split('-')[0] === currentSku && currentSku != '');
    
    const linkedProductsLimit = isProductCard ? window.themeVariables.settings.productCardSwatchesLimit : linkedProducts.length;
    const currentColorElem = document.querySelector('[data-current-color]');
    const activeLinked = linkedProducts.find(linked => linked.sku === linkedProductContainer.dataset.currentSku);

    // Insert linked products into the DOM 
    linkedProducts.slice(0, linkedProductsLimit).forEach(linked => {
      const color = linked.color;
      const colorSwatch = linked.colorSwatch;
      linkedProductContainer.insertAdjacentHTML('beforeend', `
        <a href="${linked.url}" class="${linked === activeLinked ? 'active' : ''} ${!linked.available ? 'unavailable' : ''}" data-color="${color}">
            <div style="background-color: ${colorSwatch};"></div>
        </a>
      `);
    });

    if (isProductCard && linkedProducts.length > window.themeVariables.settings.productCardSwatchesLimit) {
      linkedProductContainer.insertAdjacentHTML('beforeend', `
      <div>+${linkedProducts.length - window.themeVariables.settings.productCardSwatchesLimit}</div>
    `);
    }

    // Add event listeners to linked product color elements

    if (location.pathname.includes('/products/')){
      const linkedColorElement = linkedProductContainer.querySelectorAll('[data-color]');
      linkedColorElement.forEach(element => {
        element.addEventListener('mouseover', () => {
          currentColorElem.textContent = element.dataset.color;
        });
        element.addEventListener('mouseleave', () => {
          currentColorElem.textContent = activeLinked?.color;
        });
      });
    }
  }
};

/**
 * Fetches all products and saves them in sessionStorage.
 */
const fetchAllProducts = async () => {
  let i = 0;
  const urls = Array.from({ length: window.themeVariables.settings.productPages }, (_, i) => `${window.themeVariables.routes.collectionsAll}?view=linked&page=${i + 1}&filter.v.availability=1&filter.v.availability=0`).map(url => fetch(url));

  const responses = await Promise.all(urls);
  const data = await Promise.all(responses.map(res => res.json()));
  const allProducts = data.flat();

  window.products = allProducts;
  sessionStorage.setItem('allProducts', JSON.stringify(allProducts)); // Save in sessionStorage

  load()

};
function load(){
  window.products = JSON.parse(sessionStorage.getItem('allProducts'));
    const linkedProductContainer = document.querySelectorAll('[data-linked-products-sku]');
    linkedProductContainer.forEach(element => {
        loadLinkedProducts(element.dataset.linkedProductsSku, element)
  })
}
// Check if all products are already in sessionStorage, otherwise fetch them
if (!sessionStorage.getItem('allProducts')) {
  fetchAllProducts();
} else {
  load()
}

document.addEventListener('form:change', () => {
  if (!sessionStorage.getItem('allProducts')) {
    fetchAllProducts();
  } else {
    load()
  }
})

